import * as apiTypes from '../../constants/Api';
import { callApiGet, formatParams } from './common';

// Create map for key values in Dawa.
const addressKeyMap = [
  {
    name: 'id',
    mappedName: 'id',
  },
  {
    name: 'href',
    mappedName: 'href',
  },
  {
    name: 'streetname',
    mappedName: 'vejnavn',
  },
  {
    name: 'number',
    mappedName: 'husnr',
  },
  {
    name: 'floor',
    mappedName: 'etage',
  },
  {
    name: 'door',
    mappedName: 'dør',
  },
  {
    name: 'additionalCityName',
    mappedName: 'supplerendebynavn',
  },
  {
    name: 'postalCode',
    mappedName: 'postnr',
  },
  {
    name: 'city',
    mappedName: 'postnrnavn',
  },
  {
    name: 'bigrecpostcode',
    mappedName: 'stormodtagerpostnr',
  },
  {
    name: 'bigreccity',
    mappedName: 'stormodtagerpostnrnavn',
  },
];

/**
 * Constructs the correct DAWA endpoint URL.
 * @param  {string} service The service to use.
 * @return {string}         The correct endpoint.
 */
const getEndpoint = service => {
  return `${apiTypes.DAWA_ENDPOINT}${service}`;
};

/**
 * Maps params and passes that to the api call.
 * @param  {string} url    The enpoint.
 * @param  {Object} params [description]
 * @return {Promise}        [description]
 */
const callAddressApiGet = (url, params, dispatch) => {
  const mappedParams = formatParams(params, addressKeyMap);
  return callApiGet(url, mappedParams, dispatch, true, false);
};

/**
 * Fetches data from DAWA used for autocomplete.
 * @param  {object} params The params to use for fetching.
 * @return {Promise} The promise generated for this request.
 */
export const getAddressAutosuggest = (params, dispatch) => {
  const service = '/adresser/autocomplete';
  return callAddressApiGet(getEndpoint(service), params, dispatch).then(response => {
    return Object.keys(response).reduce((result, key) => {
      if (key === 'usedParams') {
        return result;
      }
      return [
        ...result,
        response[key],
      ];
    }, []);
  });
};

export const getPostalCode = (params, dispatch) => {
  const service = '/postnumre/autocomplete';
  return callAddressApiGet(getEndpoint(service), params, dispatch).then(response => {
    return Object.keys(response).reduce((result, key) => {
      if (key === 'usedParams') {
        return result;
      }
      return [
        ...result,
        response[key],
      ];
    }, []);
  });
};
